import { isValid as isValidIban } from 'iban';
import { AsYouType, isValidPhoneNumber } from 'libphonenumber-js';
import dayjs from 'dayjs';
// import { getLastWord } from '../../libs/strings'
import i18n from '../../translations/i18n';
import { Apartment, BeforeLoginApartment } from '../../types/apartments';
import { AutocompleteOption } from '../../types/autocomplete';
import { isInFuture, isValidDate } from '../dates';
import { arrayOfCities } from './listOfCitiesForPostalArea';
// TODO translations don't change real time here
const required = (value?: string) => value ? undefined : i18n.t('validation.required');
// const streetNumberRequiredHelper = (input: string) => {
//   const lastWord = getLastWord(input)
//   const addressNumberStartsWithNumber = lastWord.match(/\d/g)
//   if (!addressNumberStartsWithNumber) {
//     return i18n.t('validation.streetNumberRequired')
//   }
//   return undefined
// }
const validateYear = (value?: string) => value && !/^\d{4}$/.test(value) ? i18n.t('validation.invalidYear') : undefined;
// Ensure construction year is at least 1699
const yearAtLeast1699 = (value?: string) => value && /^\d{4}$/.test(value) && parseInt(value, 10) < 1699
    ? i18n.t('validation.minYear1699')
    : undefined;
const isInvalidCharacters = (value?: string) => value && /[&<>'"]/g.test(value)
    ? i18n.t('validation.invalidCharacters')
    : undefined;
const requiredLocation = (value?: string | AutocompleteOption) => {
    if (!value || value === '' || value === null) {
        return i18n.t('validation.addressRequired');
    }
    // if (
    //   typeof value === 'object' &&
    //   typeof value?.label === 'string' &&
    //   value.label !== ''
    // ) {
    //   return streetNumberRequiredHelper(value.label)
    // }
    // if (typeof value === 'string') {
    //   return streetNumberRequiredHelper(value)
    // }
    return undefined;
};
const getValueObject = (apartment: Apartment | BeforeLoginApartment | undefined, options: any[], key: any) => {
    if (apartment && apartment.information && key) {
        const obj = (apartment.information as any)[key];
        return options.find((data: any) => data.value === obj);
    }
};
const requiredStartDate = (value?: string) => value ? undefined : i18n.t('validation.chooseStartDate');
const requiredEndDate = (value?: string) => value ? undefined : i18n.t('validation.chooseEndDate');
const requiredStartTime = (value?: string) => value ? undefined : i18n.t('validation.tooLate');
const requiredEndTime = (value?: string) => value ? undefined : i18n.t('validation.tooEarly');
const requiredFalsyString = (value: string) => /\S+/g.test(value) ? undefined : i18n.t('validation.required'); // Needs work
const noSpacesPhoneNum = (value?: string) => value && /\s/g.test(value) ? i18n.t('validation.phoneNumberError') : undefined;
const noSpaceValue = (value?: string) => value && /\s/g.test(value) ? i18n.t('validation.noSpaceError') : undefined;
const stripSpaces = (value?: string) => (typeof value === 'string' ? value.replace(/\s/g, '') : value);
const stripLeadingSpaces = (value?: string) => (typeof value === 'string' ? value.replace(/^\s+/, '') : value);
const validateEmail = (value?: string) => value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)
    ? i18n.t('validation.invalidEmail')
    : undefined;
const validatePassword = (value?: string) => value && value.length > 5 ? undefined : i18n.t('validation.pwComplexity');
const passwordsMatch = (value: string, allValues: any) => value !== allValues.password ? i18n.t('validation.pwNoMatch') : undefined;
// 1–4 digits per part ("3", "1108", "5-7"); a 5-digit value is a postal code typed in the wrong field
const isStreetNumber = (value?: string) => value && !/^[0-9]{1,4}(?:-[0-9]{1,4})?$/.test(value)
    ? i18n.t('validation.streetNumber')
    : undefined;
const isPostalCode = (value?: string) => value && !/^[0-9]{1,5}$/i.test(value)
    ? i18n.t('validation.postalCode')
    : undefined;
const rentPrice = (value?: string) => value && !/^[0-9]{1,6}$/i.test(value)
    ? i18n.t('validation.priceInNumbers')
    : undefined;
const mediaRequired = (value: any) => (!value ? 'Required' : undefined);
const lessOrEqualThanFloors = (value: string, allValues: any) => parseInt(value, undefined) > parseInt(allValues.floors, undefined)
    ? i18n.t('validation.floorTooHigh')
    : undefined;
const moreOrEqualThanFloor = (value: string, allValues: any) => parseInt(value, undefined) < parseInt(allValues.floor, undefined)
    ? i18n.t('validation.notEnoughFloors')
    : undefined;
const lessThanAvailableUntil = (value: string, allValues: any) => allValues.availableUntilDate && value > allValues.availableUntilDate
    ? i18n.t('validation.chooseStartDate')
    : undefined;
const isNumericOrEmpty = (value: any) => {
    if (value === undefined || value === null || value === '' || value === 'undefined')
        return undefined;
    if (!/^\d+$/.test(value)) return i18n.t('validation.mustBeNumber');
    return parseInt(value, 10) > 50 ? i18n.t('validation.floorInvalid') : undefined;
};
const greaterThanAvailableFrom = (value: string, allValues: any) => value < allValues.availableFromDate
    ? i18n.t('validation.chooseEndDate')
    : undefined;
const lessThanEndTime = (value: string, allValues: any) => value > allValues.endTime ? i18n.t('validation.chooseStartDate') : undefined;
const greaterThanStartTime = (value: string, allValues: any) => value < allValues.startTime ? i18n.t('validation.chooseEndDate') : undefined;
const lessThanEndDate = (value: string, allValues: any) => value > allValues.endDate ? i18n.t('validation.chooseStartDate') : undefined;
const onlyFutureEvents = (_value: string, allValues: any) => {
    const startDate = dayjs(allValues.dateRange.startDate)
        .hour(allValues.time.startTime.hour())
        .minute(allValues.time.startTime.minute())
        .second(0)
        .valueOf();
    const availableDate = dayjs()
        .hour(dayjs().hour() + 2)
        .second(0)
        .valueOf();
    return !isInFuture(startDate, availableDate)
        ? i18n.t('error.showings.allowOnlyFutureEvents2h')
        : undefined;
};
const greaterThanStartDate = (value: string, allValues: any) => value < allValues.startDate ? i18n.t('validation.chooseEndDate') : undefined;
const validateTime = (value: any) => !isValidDate(value) ? i18n.t('validation.invalidTime') : undefined;
const validateDayTime = (value: any): string | undefined => {
    const minutes = dayjs(value).hour() * 60;
    return minutes >= 8 * 60 && minutes <= 20 * 60 + 30
        ? undefined
        : i18n.t('error.showings.tooEarlyOrLate');
};
const validateIban = (value: string): any => value && value.trim() && !isValidIban(value)
    ? i18n.t('validation.invalidIban')
    : undefined;
const validateMinAvailabilitiesLength = (length: number) => (value: any[]) => value && value.length < length
    ? i18n.t('validation.availabilitiesLength')
    : undefined;
const validateOnlyFutureEvents = (value: any, allValues: any) => {
    const startDateDayjs = dayjs(allValues.dateRange.startDate);
    const now = dayjs();
    const startTimeDayjs = dayjs(value.startTime);
    return startDateDayjs.format('DD.MM.YYYY') === now.format('DD.MM.YYYY') &&
        startTimeDayjs.hour() * 60 +
            startTimeDayjs.minute() -
            (now.hour() * 60 + now.minute()) <
            120
        ? i18n.t('error.showings.allowOnlyFutureEvents2h')
        : undefined;
};
const validatePostalArea = (value?: any) => {
    return value &&
        arrayOfCities.findIndex((item) => typeof value === 'object'
            ? value?.value.toLowerCase() === item.value.toLowerCase()
            : value.toLowerCase() === item.value.toLowerCase()) !== -1
        ? undefined
        : i18n.t('validation.wrongCity');
};
const validatePhoneNumber = (value?: string) => {
    const tempValue = value?.charAt(0) === '+' ? value : `+358${value}`;
    if (!value)
        return i18n.t('validation.noSpaceError');
    const asYouType = new AsYouType();
    asYouType.input(tempValue);
    return !isValidPhoneNumber(tempValue)
        ? i18n.t('validation.phoneNumberError')
        : undefined;
};
export { required, requiredLocation, requiredStartDate, requiredEndDate, requiredStartTime, requiredEndTime, requiredFalsyString, onlyFutureEvents, noSpacesPhoneNum, noSpaceValue, stripSpaces, stripLeadingSpaces, validateEmail, validatePassword, passwordsMatch, rentPrice, isPostalCode, isStreetNumber, mediaRequired, lessOrEqualThanFloors, moreOrEqualThanFloor, lessThanAvailableUntil, greaterThanAvailableFrom, lessThanEndTime, greaterThanStartTime, lessThanEndDate, greaterThanStartDate, isInvalidCharacters, validateTime, validateDayTime, validateMinAvailabilitiesLength, validateOnlyFutureEvents, validateIban, validatePostalArea, validatePhoneNumber, validateYear, yearAtLeast1699, getValueObject, isNumericOrEmpty };
